<template>
    <div class="machine_config bg-dark">
     <div class="alert" role="alert" id="snackbar">
        <strong>Error:</strong> All fields are requred!!!
        </div>
       <div class="alert" role="alert" id="snackbar1">
        <strong>Success:</strong>Pulses/minute has been updated!!!
        </div>
        <form class="config">
          <div class="form-group">
            <label for="name">Mechine Name:</label>
            <input type="text" class="form-control" placeholder="" id="machineName" v-model="machineName" disabled>
          </div>

          <div class="form-group">
            <label for="pulse">Pulse / meter:</label>
            <input type="text" class="form-control" placeholder="Enter pulses / minute" id="pulses" v-model="pulseConfig">
          </div>

          <div class="form-group">
            <label for="threshold">Comm interval:</label>
            <input type="text" class="form-control" placeholder="Enter communication interval x2" id="comm_interval" :value="comm_interval / 60">
          </div>

          <div class="form-group">
            <label for="threshold">Meters / minute:</label>
            <input type="text" class="form-control" placeholder="Enter threshold" id="threshold" v-model="threshold">
          </div>
          <div class="form-group"> 
            <label for="moniteredInput">Monitered Input:</label>
            <select class="form-control" v-model="MonitorInput" id="moniteredInput">
                <option disabled selected>Choose Monitered Input</option>
                <option v-for="input in inputs" :key="input.id" :value="input.PacketType">
                 {{ input.Input }}
                </option>
            </select>
          </div>
            <button type="button" class="btn-sm btn-info" @click="updateConfig(machine.ramacDevice)">Submit</button>
            <router-link tag="button" to="/Extruder" class="btn-sm btn-danger">Back</router-link>
        </form>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
      return {
      states: [
              'On',
              'Off'
            ],
      inputs: [],
      machineName: '',
      position: '',
      product: '',
      site: '',
      ramacDevice: '',
      machinesType: '',
      pulseConfig: '',
      threshold: '',
      comm_interval: '',
      machine_state: '',
      MonitorInput: '',
      }
    },

    mounted() {
      this.getMachine()
    },

    computed: {
    commInterval() {
      return this.machine.comm_interval / 60;
    }
  },

    methods: {
      getMachine() {
        axios.get('https://m4a.ramacsystems.com/backend/mechines/addGet.php?params', {
          params: {
            action: 'getMachineDetails',
            machineName: this.$route.params.machineName
          }
        })
        .then((res) => {
          this.machine = res.data[0]
          console.log(res.data[0])
          this.machineName = res.data[0].machineName
          this.ramacDevice = res.data[0].ramacDevice
          this.pulseConfig = res.data[0].pulseConfig
          this.threshold = res.data[0].threshold
          this.comm_interval = res.data[0].comm_interval
          this.MonitorInput = res.data[0].MonitorInput
          this.getAllInputs()
        })
        .catch(function (error) {
            console.log(error)
        })
      },

      getAllInputs() {
          axios.get('https://m4a.ramacsystems.com/backend/mechines/machine_config/machine_config.php', {
            params: {
              action: 'getAllInputs',
            }
          })
          .then((res) => {
            this.inputs = res.data
            // console.log(this.inputs)
          })
          .catch(function (error) {
              console.log(error)
          })
      },

      updateConfig(ramacDevice) {
            if (this.machine.pulseConfig === '') {
              //VALIDATION FIELDS ARE EMPTY
              if (this.machine.machineName == '') {
                document.getElementById("machineName").style.border = "1px solid red";
              }
              if(this.machine.pulse == '') {
                document.getElementById("pulses").style.border = "1px solid red";
              }
              if(this.machine.threshold == '') {
                document.getElementById("threshold").style.border = "1px solid red";
              }
              if(this.machine.comm_interval == '') {
                document.getElementById("comm_interval").style.border = "1px solid red";
              }
              //VALIDATION FIELDS ARE EMPTY
             var x = document.getElementById("snackbar");
                x.className = "show";
                setTimeout(function(){ 
                x.className = x.className.replace("show", "");
             }, 1000);
         } else {
              //AUDIT LOG PARAMS
            let fullname_user = localStorage.getItem('fullname') 
            let user_action = 'Edit Configuration'
            let description = fullname_user +" changed configurations setting for " + this.machine.machineName
            let pulseConfig = this.machine.pulseConfig
            let threshold = this.machine.threshold
            let state = this.machine.machine_state
            let comm_interval = document.getElementById('comm_interval').value * 60
            let product = "Default_Product"
            axios.get('https://m4a.ramacsystems.com/backend/mechines/editMachine.php?params', {
                params: {
                    ramacDevice,
                    pulseConfig,
                    threshold,
                    state,
                    comm_interval,
                    product,
                    fullname_user,
                    MonitorInput: this.MonitorInput,
                    user_action,
                    description
                }
            })
            .then((res) => {
                console.log(res)
                var x = document.getElementById("snackbar1");
                x.className = "show";
                setTimeout(function(){ 
                x.className = x.className.replace("show", "");
             }, 500);

            setTimeout(() => {
             this.$router.go(-1)
            }, 500)
            })
          }
        }
    }
}
</script>

<style scoped>
.btn {
    margin-right: 10px;
}

input,
select {
    width: 50%;
    margin-left: 25%;
}

label {
  color: #bdb8d7;
}

button {
    margin: 10px;
}
.alert {
    width: 30%;
}

#snackbar {
	visibility: hidden;
	min-width: 250px;
    margin-left: -125px;
    text-align: center;
    background-color: #ff9966 !important;
	border-radius: 2px;
	padding: 5px;
	position: fixed;
	z-index: 1;
	left: 50%;
    top: 10px;
	font-size: 17px;
  }
  
  #snackbar.show {
	visibility: visible;
	-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
	animation: fadein 0.5s, fadeout 0.5s 2.5s;
  }

#snackbar1 {
	visibility: hidden;
	min-width: 250px;
    margin-left: -125px;
    text-align: center;
    background-color: #5cff3b !important;
	border-radius: 2px;
	padding: 5px;
	position: fixed;
	z-index: 1;
	left: 50%;
    top: 10px;
	font-size: 17px;
  }
  
  #snackbar1.show {
	visibility: visible;
	-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
	animation: fadein 0.5s, fadeout 0.5s 2.5s;
  }
</style>